import React from 'react';
import styled, { css } from 'styled-components';
import { device } from '../../providers/theme';
import Menu from '../Menu';
import { Link } from 'gatsby';
import Bubbles from '../Bubbles';

const Container = styled.div`
  position: relative;
  height: 100%;
  ${props =>
    props.clip &&
    css`
      clip-path: ${props => props.themeColor};
    `}
`;

const Content = styled.div`
  width: 100%;
  height: 150px;
  background: ${props => props.themeColor};
  transition: background 0.1s ease-in;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 calc(5vw + 22px);

  @media screen and (max-width: 1240px) {
    padding: 12px;
  }

  @media ${device.tablet} {
    padding: 0 44px;
  }

  @media ${device.mobile} {
    padding: 0 22px;
  }
`;

const Title = styled.p`
  font-family: 'Thasadith', 'Cabin', sans-serif;
  font-size: 4rem;
  color: ${props => props.theme.fontColors.white};
  margin: 0 0 18px;

  @media ${device.mobile} {
    font-size: 2rem;
  }
`;

const Subtitle = styled.h2`
  font-size: 1rem;
  color: ${props => props.theme.fontColors.white};
  margin: 0;
  font-weight: 100;
`;

const Wave = styled.div`
  width: 100%;
  background: transparent;
`;

const SVG = styled.svg`
  @media ${device.tablet} {
    margin-top: -1px;
  }
  path {
    fill: ${props => props.themeColor};
    transition: fill 0.1s ease-in;
  }
`;

function TopSection({ themeColor, type }) {
  return (
    <Container themeColor={themeColor}>
      <Content themeColor={themeColor}>
        <div style={{ zIndex: '1' }}>
          <Link to="/">
            <Title>Vinkammeret</Title>
          </Link>
          <Subtitle>
            Mere end 6.000 vine samlet fra landets forhandlere
          </Subtitle>
        </div>
        <Menu />
      </Content>
      <Wave>
        <SVG
          themeColor={themeColor}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
        >
          <path d="M0,288L7.5,288C15,288,30,288,45,256C60,224,75,160,90,122.7C105,85,120,75,135,64C150,53,165,43,180,74.7C195,107,210,181,225,224C240,267,255,277,270,277.3C285,277,300,267,315,229.3C330,192,345,128,360,101.3C375,75,390,85,405,112C420,139,435,181,450,213.3C465,245,480,267,495,245.3C510,224,525,160,540,144C555,128,570,160,585,160C600,160,615,128,630,117.3C645,107,660,117,675,128C690,139,705,149,720,170.7C735,192,750,224,765,208C780,192,795,128,810,106.7C825,85,840,107,855,138.7C870,171,885,213,900,202.7C915,192,930,128,945,96C960,64,975,64,990,53.3C1005,43,1020,21,1035,32C1050,43,1065,85,1080,101.3C1095,117,1110,107,1125,106.7C1140,107,1155,117,1170,112C1185,107,1200,85,1215,96C1230,107,1245,149,1260,176C1275,203,1290,213,1305,197.3C1320,181,1335,139,1350,138.7C1365,139,1380,181,1395,176C1410,171,1425,117,1433,90.7L1440,64L1440,0L1432.5,0C1425,0,1410,0,1395,0C1380,0,1365,0,1350,0C1335,0,1320,0,1305,0C1290,0,1275,0,1260,0C1245,0,1230,0,1215,0C1200,0,1185,0,1170,0C1155,0,1140,0,1125,0C1110,0,1095,0,1080,0C1065,0,1050,0,1035,0C1020,0,1005,0,990,0C975,0,960,0,945,0C930,0,915,0,900,0C885,0,870,0,855,0C840,0,825,0,810,0C795,0,780,0,765,0C750,0,735,0,720,0C705,0,690,0,675,0C660,0,645,0,630,0C615,0,600,0,585,0C570,0,555,0,540,0C525,0,510,0,495,0C480,0,465,0,450,0C435,0,420,0,405,0C390,0,375,0,360,0C345,0,330,0,315,0C300,0,285,0,270,0C255,0,240,0,225,0C210,0,195,0,180,0C165,0,150,0,135,0C120,0,105,0,90,0C75,0,60,0,45,0C30,0,15,0,8,0L0,0Z"></path>
        </SVG>
      </Wave>
      {type &&
        (type.toLowerCase() === 'champagne' ||
          type.toLowerCase() === 'mousserende') && <Bubbles />}
    </Container>
  );
}

export default TopSection;
